import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const Employee = React.lazy(() => import("@/pages/people/employee/Employee"));
const Chart = React.lazy(() => import("@/pages/people/chart"));
const MyTeams = React.lazy(() => import("@/pages/people/myTeams/MyTeams"));
const Graphics = React.lazy(() => import("@/pages/people/graphics/Graphics"));
const Index = React.lazy(() => import("@/pages/people/index.jsx"));
const Peoples = [
  {
    path: "orgChart",
    element: (
      <SuspenseWrapper>
        <Chart />
      </SuspenseWrapper>
    ),
  },
  {
    path: "myTeam",
    element: (
      <SuspenseWrapper>
        <MyTeams />
      </SuspenseWrapper>
    ),
  },
  {
    path: "graphics",
    element: (
      <SuspenseWrapper>
        <Graphics />
      </SuspenseWrapper>
    ),
  },
  {
    path: "people",
    element: (
      <SuspenseWrapper>
        <Index />
      </SuspenseWrapper>
    ),
  },
  {
    path: "employee",
    element: (
      <SuspenseWrapper>
        <Employee />
      </SuspenseWrapper>
    ),
  },
];

export default Peoples;
